import { QueryObserverResult } from '@tanstack/react-query'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalQuery } from 'src/Libs/api'
import { AccountLinkModel } from 'src/Libs/installation-rights-management/models'
import { getAccountLinkByAccountId } from '../api'

type UseAccountLinkByAccountIdReturnType = [AccountLinkModel | null, boolean, () => Promise<QueryObserverResult<AccountLinkModel | null, Error>>]

/**
 * Hook to get account link by specific account link id
 * @param installationId - Installation id
 * @param accountId - Account id
 */
export const useAccountLinkByAccountLinkId = (
  installationId: number | string | undefined,
  accountId: number | string | undefined
): UseAccountLinkByAccountIdReturnType => {
  const authFetch = useAuthFetchWithResponse()

  const getAccountLinkByAccountIdQueryFn = async (): Promise<AccountLinkModel | null> => {
    const { error, hasErrors, value } = await getAccountLinkByAccountId(`${installationId}`, `${accountId}`, authFetch)

    if (hasErrors) {
      throw error || new Error('An unexpected error occurred while fetching accountLink data')
    }

    return value
  }

  const { data, isLoading, refetch } = usePortalQuery({
    queryKey: ['installations', installationId, 'account-links', '?accountId=', accountId],
    queryFn: getAccountLinkByAccountIdQueryFn,
    enabled: !!installationId && !!accountId,
  })

  return [data ?? null, isLoading, () => refetch()]
}
